<div class='security-form-container' fxLayout='column' fxFill>
  <div fxLayout='column' fxLayoutAlign='space-around' fxFlex>
    <button mat-button color='primary' class='information-plaque'>
      <h3>
        {{ cService.readyTranslations.security.v2TokenLogOn | uppercase }}
        <div class='margin-t-10 margin-b-10'>
          <mat-divider></mat-divider>
        </div>
        <div *ngIf='!ssoFailed && !signInDone'>
          {{ cService.readyTranslations.messagesAndWarnings.inProgress }}...
        </div>
        <div *ngIf='!ssoFailed && signInDone' class='green-text'>
          {{ cService.readyTranslations.generic.done }}
        </div>
      </h3>
    </button>

    <div *ngIf='ssoFailed' class='margin-t-25 red-text text-align-c'>
      <h4>{{ cService.readyTranslations.security.v2TokenLoginFailed }}</h4>
    </div>
  </div>

  <app-footer></app-footer>
</div>
